import React from "react";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";

import { styled } from "@mui/material/styles";

const PrimaryText = styled(Typography)(props => ({
  color: "white",
  lineHeight: 1.25,
  marginBottom: "0.3rem",
  paddingBottom: "0.2rem",
  overflow: "hidden",
  fontWeight: props.istTitel ? "bold" : "normal"
}));

const SecondaryText = styled(Typography)(props => ({
  color: "white",
  lineClamp: 2,
  maxHeight: "50px",
  display: "-webkit-box",
  "-webkit-box-orient": "vertical",
  lineHeight: 1.25,
  marginBottom: "0.3rem",
  paddingBottom: "0.2rem",
  overflow: "hidden",
  fontWeight: props.istTitel ? "bold" : "normal"
}));

const Header = styled("div")`
  min-height: 75px;
  max-height: 75px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

function MaterialPreviewHeader({ primaryText, secondaryText, istTitel }) {
  return (
    <Header>
      <PrimaryText
        variant="subtitle1"
        noWrap
        sx={{
          display: "block"
        }}
        istTitel={istTitel}
      >
        {primaryText}
      </PrimaryText>
      {secondaryText && (
        <SecondaryText
          variant="subtitle1"
          noWrap={false}
          sx={{
            display: "block"
          }}
          istTitel={istTitel}
        >
          {secondaryText}
        </SecondaryText>
      )}
    </Header>
  );
}

MaterialPreviewHeader.propTypes = {
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  istTitel: PropTypes.bool
};

MaterialPreviewHeader.defaultProps = {
  primaryText: "",
  secondaryText: ""
};

export default MaterialPreviewHeader;
